import { render, staticRenderFns } from "./AnfragenOpen.vue?vue&type=template&id=4ee91cc8&scoped=true"
import script from "./AnfragenOpen.vue?vue&type=script&lang=js"
export * from "./AnfragenOpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee91cc8",
  null
  
)

export default component.exports